import { render, staticRenderFns } from "./ModalRemanejarAtendimento.vue?vue&type=template&id=4edc54fe"
import script from "./ModalRemanejarAtendimento.vue?vue&type=script&lang=js"
export * from "./ModalRemanejarAtendimento.vue?vue&type=script&lang=js"
import style0 from "./ModalRemanejarAtendimento.vue?vue&type=style&index=0&id=4edc54fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports